module.exports = __webpack_public_path__ + "static/media/munin-sad2.fa332780.svg";